@if (!user()?.is_basic_subscribed) {
  <div (click)="onSubscribe()" class="bg-red-500 rounded-[20px] px-3 py-3 text-white! flex items-center gap-2 w-full cursor-pointer">
    <div>
      <div class="rounded-full border border-white max-w-max flex items-center gap-0.5 px-3 py-0.5 mb-1">
        <sens-icon [size]="16" icon="#icon-star"/>
        <p class="text-base/4 font-bold">Premium</p>
      </div>
      <p class="text-sm/5 font-bold">Unlock Premium content from models</p>
    </div>

    <div class="bg-white rounded-full text-red-500 py-1.5 px-3 ml-auto">
      <sens-icon [size]="20" icon="#icon-chevron-right "/>
    </div>
  </div>
}
